+function ($) {
    'use strict';

    var ToolTip = function (element, option) {
        this.targetElement = $(element);
        this.message = this.targetElement.data('tooltip-msg');
        if (!this.message) {
            return;
        }
        this.template = '<div class="tooltip"></div>';

        this.tooltip = $(this.template).html(this.message);
        if (this.targetElement.css('display') == 'none') {
            var showedTargetElement = this.targetElement;
            while(showedTargetElement.css('display') == 'none') {
                showedTargetElement = showedTargetElement.parent();
            }
            this.showedTargetElement = showedTargetElement;
        }
        this.callibrate();
        $('body').append(this.tooltip);

        var self = this;
        $('*').bind('scroll', function () {
            self.callibrate();
        });

        this.targetElement.bind('focus', function () {
            self.tooltip.remove();
            self.tooltip = null;
        });
    };

    //Производим каллибровку элемента tooltip
    ToolTip.prototype.callibrate = function () {
        if (this.tooltip) {
            var targetElement;
            if (this.showedTargetElement) {
                targetElement = this.showedTargetElement;
            } else {
                targetElement = this.targetElement;
            }
            var top = targetElement.offset().top;
            var left = targetElement.offset().left;
            top = top + targetElement.outerHeight();
            var width = targetElement.outerWidth();
            this.tooltip.css({
                'top': top,
                'left': left,
                'max-width': width,
            });
        }
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new ToolTip(this, options)
        });
    };



    var old = $.fn.ToolTip;

    $.fn.ToolTip = constructor;
    $.fn.ToolTip.constructor = constructor;

    $.fn.ToolTip.noConflict = function () {
        $.fn.ToolTip = old;
        return this;
    }
}(jQuery);